/* eslint-disable warp-drive/no-legacy-request-patterns */
import Route from '@ember/routing/route';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { service } from '@ember/service';
import NSWStatus from '@linc-technologies/linced-common/enums/nsw-status';

export default class IndexRoute extends Route {
  // Services
  @service
  session;

  @service
  store;

  model() {
    return hash({
      batches: this.store.findAll('medical/batch'),
      medications: this.store.findAll('medical/medication'),
      learners: this.store.query('person', { type: PersonType.LEARNER }),
      logs: this.store.findAll('medical/log'),
      schedules: this.store.findAll('medical/schedule'),
      locations: this.store
        .query('schools/location', {
          schoolId: this.session.activeSchool,
        })
        .then((locations) => {
          // Filter active locations and then sort by name in ascending order
          return locations
            .filter((location) => location.status === NSWStatus.ACTIVE)
            .sort((a, b) => (a.name || '').localeCompare(b.name || ''));
        }),
    });
  }

  // The controller is a singleton, but each FilterInput is empty when the
  // page shows again. Clear the filters when the user leaves the page, so
  // that no filter stays that the user cannot see.
  resetController(controller, isExiting) {
    if (isExiting) {
      controller.filters = [];
    }
  }
}
